// extracted by mini-css-extract-plugin
export default {"pageUpdates":"page-updates_pageUpdates__38xB7","container":"page-updates_container__8S0PI"};